'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'arrow-down-to-line';
var width = 384;
var height = 512;
var aliases = ["arrow-to-bottom"];
var unicode = 'f33d';
var svgPathData = ['', 'M8 480c-4.4 0-8-3.6-8-8s3.6-8 8-8l368 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 480zm189.7-98.3c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L184 356.7 184 40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L322.3 234.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-136 136z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowDownToLine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;